import { render, staticRenderFns } from "./collection.vue?vue&type=template&id=11ba3728&scoped=true"
import script from "./collection.vue?vue&type=script&lang=js"
export * from "./collection.vue?vue&type=script&lang=js"
import style0 from "./collection.vue?vue&type=style&index=0&id=11ba3728&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ba3728",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11ba3728')) {
      api.createRecord('11ba3728', component.options)
    } else {
      api.reload('11ba3728', component.options)
    }
    module.hot.accept("./collection.vue?vue&type=template&id=11ba3728&scoped=true", function () {
      api.rerender('11ba3728', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recommended/collection.vue"
export default component.exports